/**
 * Layout wrapper component with sidebar navigation
 */

import type { ReactNode } from 'react';
import React from 'react';
import { Sidebar } from './Sidebar';
import { MobileHeader } from './MobileHeader';

interface LayoutProps {
  children: ReactNode;
  onShowUserModal?: () => void; // Deprecated, kept for compatibility
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile Header with Drawer */}
      <div className="md:hidden">
        <MobileHeader />
      </div>

      {/* Main Content Area */}
      <main className="md:ml-60">{children}</main>
    </div>
  );
}
